import React from 'react';
import { SvgIcon } from '@mui/material';

export default function PresentIcon(props) {
  return (
    <SvgIcon sx={{ width: 48, height: 48 }} {...props}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.5"
          d="M40.4452 11.5332C41.0618 11.6118 42.5099 12.1735 42.7654 13.0201C43.0209 13.8668 43.0222 17.6407 42.9157 19.1893C42.8521 19.7186 42.2809 20.4453 41.1069 20.6334C41.0556 20.6417 41.0093 20.6399 40.9676 20.6286C40.6563 20.6367 40.331 20.7828 40.2105 21.3385C40.0717 21.9781 40.2105 33.4591 40.2105 39.2155C40.2105 39.9406 39.0614 40.5208 37.8818 40.4889L38.5459 21.3385L38.9332 20.5454L40.6531 20.0093C40.4737 18.5486 41.1702 14.8024 40.4452 11.5332Z"
          fill="white"
        />
        <path
          d="M7.37347 18.9921C7.68591 20.659 9.51318 20.6682 10.5592 20.7007H38.9027C40.315 20.7007 40.7706 20.0569 40.836 19.5013V12.93C40.836 11.7528 39.5565 11.6305 38.9027 11.5977H9.18594C8.08736 11.5977 7.37347 12.3574 7.37347 13.4996C7.40613 14.8073 7.1417 17.7556 7.37347 18.9921Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M14.9303 11.131C14.6737 10.0224 14.7516 7.76842 17.1163 7.62075C19.4809 7.47307 21.4268 9.09876 22.1041 9.93007"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M26.8145 10.0523C27.0604 9.74422 29.5846 6.8184 31.4014 7.43461C33.2182 8.05082 33.5569 9.46692 33.4953 10.9448"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M38.2689 21.0742V38.7468C38.2689 39.2487 38.2689 40.06 37.6805 40.0992C36.9748 40.1463 23.3344 40.1188 17.2969 40.0992"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <rect
          x="21.6328"
          y="11.7227"
          width="5.5703"
          height="28.4023"
          fill="white"
        />
        <circle
          cx="24.4179"
          cy="11.1581"
          r="1.91009"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M12.1064 21.0195L11.1691 26.4058"
          stroke="#29EDFF"
          strokeWidth="1.04546"
          strokeLinecap="round"
        />
        <path
          d="M6.6183 28.1471L11.3362 24.9781L14.7384 29.3152C14.3137 32.7541 13.4285 39.7146 13.2849 40.0458C13.0056 40.6903 12.5089 40.5327 12.2143 40.5165C10.1397 40.3352 6.52625 39.8276 6.01295 39.6681C5.37134 39.4688 5.14564 39.1053 5.12108 38.7307C5.10143 38.4311 6.11094 31.5501 6.6183 28.1471Z"
          fill="#29EDFF"
        />
        <circle
          cx="10.6573"
          cy="30.007"
          r="1.43081"
          transform="rotate(4.99452 10.6573 30.007)"
          fill="#4520AB"
        />
      </svg>
    </SvgIcon>
  );
}
